/* @flow weak */
import * as React from 'react';
import BoxBody from 'components/BoxBody';
import Button from 'components/Button';
import List from 'components/List';
import Row from 'components/Row';
import TextWithGlyph from 'components/TextWithGlyph';
import TitleHeader from 'components/TitleHeader';

import type { GlyphName } from '@remind/r101-glyphs';

type Props = {
  name: string,
  onCancel: () => void,
};

function PhoneCallInitializingViewFeaturesItem(props: { children?: React.Node, glyph: GlyphName }) {
  const { children, glyph } = props;

  return (
    <TextWithGlyph glyph={glyph} glyphColor="eclipse" glyphSize="medium">
      {children}
    </TextWithGlyph>
  );
}

function PhoneCallInitializingView(props: Props) {
  const name = props.name || '';

  return (
    <div className="PhoneCallInitializingView">
      <BoxBody>
        <TitleHeader
          subtext={`After you pick up, we’ll connect you with ${name}`}
          title="Answer your phone"
        />
        <Row>
          <List center size="large">
            <PhoneCallInitializingViewFeaturesItem glyph="lock">
              Personal phone numbers stay private
            </PhoneCallInitializingViewFeaturesItem>
            <PhoneCallInitializingViewFeaturesItem glyph="chat-check-bubble">
              All calls are logged on Remind
            </PhoneCallInitializingViewFeaturesItem>
            <PhoneCallInitializingViewFeaturesItem glyph="clock">
              You’ll only get calls during office hours
            </PhoneCallInitializingViewFeaturesItem>
          </List>
        </Row>
        <Button level="secondary" onClick={props.onCancel} color="lava">
          Cancel
        </Button>
      </BoxBody>
    </div>
  );
}
export default PhoneCallInitializingView;
